import { v } from 'h3-valibot';

export const PDP_BANNER_STYLES = [
  'info',
  'warning',
  'danger',
  'success',
  'neutral'
] as const;

export const PDP_BANNER_STYLE_VARIANTS = ['primary', 'secondary'] as const;

export type PdpBannerStyle = (typeof PDP_BANNER_STYLES)[number];
export type PdpBannerStyleVariant = (typeof PDP_BANNER_STYLE_VARIANTS)[number];

/**
 * Contentful `technicalComponent` configuration for `type: pdpBanner`.
 *
 * `attributCondtitions` mirrors the CMS field spelling (typo kept intentional
 * for compatibility with existing entries).
 */
export const pdpBannerConfigurationSchema = v.object({
  dictKey: v.pipe(v.string(), v.minLength(1)),
  icon: v.optional(v.string()),
  style: v.picklist(PDP_BANNER_STYLES),
  styleVariant: v.optional(v.picklist(PDP_BANNER_STYLE_VARIANTS)),
  attributCondtitions: v.optional(v.record(v.string(), v.string()))
});

export type ParsedPdpBannerConfiguration = {
  dictKey: string;
  icon?: string;
  style: PdpBannerStyle;
  styleVariant?: PdpBannerStyleVariant;
  /** Magento/product attribute filters; CMS key is `attributCondtitions`. */
  attributeConditions?: Record<string, string>;
};
